import React, { useState, useEffect } from "react";
// import { Link } from "react-scroll"; // Removido para resolver o erro de dependência

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const toggleMenu = () => setIsOpen(!isOpen);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { to: "hero", label: "Início" },
        { to: "about", label: "Sobre" },
        { to: "projects", label: "Serviços" },
        { to: "experience", label: "Projetos" },
        { to: "contact", label: "Contato" },
    ];

    // Função para lidar com o clique e o scroll suave
    const handleLinkClick = (e, targetId) => {
        e.preventDefault();
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
        if (isOpen) {
            toggleMenu();
        }
    };

    return (
        <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-bege/90 shadow-md backdrop-blur-sm' : 'bg-transparent'}`}>
            <div className="container mx-auto flex justify-between items-center p-4">
                <a href="#hero" onClick={(e) => handleLinkClick(e, 'hero')} className="text-xl font-bold text-brand-grafite tracking-wide font-montserrat">
                    Karlla Barbosa
                </a>

                <nav className="hidden md:block">
                    <ul className="flex space-x-8 text-brand-grafite font-medium">
                        {navLinks.map(link => (
                            <li key={link.to}><a href={`#${link.to}`} onClick={(e) => handleLinkClick(e, link.to)} className="cursor-pointer hover:text-brand-savia transition-colors">{link.label}</a></li>
                        ))}
                    </ul>
                </nav>

                <button
                    className="md:hidden text-brand-grafite focus:outline-none"
                    onClick={toggleMenu}
                    aria-label="Abrir menu"
                >
                    {isOpen ? (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" /></svg>
                    )}
                </button>
            </div>

            {isOpen && (
                <nav className="md:hidden bg-brand-bege shadow-lg">
                    <ul className="flex flex-col space-y-4 p-6 text-brand-grafite font-medium text-center">
                        {navLinks.map(link => (
                            <li key={link.to}><a href={`#${link.to}`} onClick={(e) => handleLinkClick(e, link.to)} className="cursor-pointer block py-2 hover:text-brand-savia">{link.label}</a></li>
                        ))}
                    </ul>
                </nav>
            )}
        </header>
    );
}

export default Header;
